module.exports = __webpack_public_path__ + "img/shiprocket-logo.02664f54.svg";